<script lang="ts">
  import { onMount } from 'svelte';

  export let modalTitle!: string;
  export let modalMessage!: string;
  export let handleCloseEvent!: any;

  let buttonElement: any;

  onMount((): void => {
    if (buttonElement) {
      buttonElement.focus();
    }
  });

  const handleClose = (): void => {
    handleCloseEvent();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-xl font-bold text-gray-700">{modalTitle}</h1>
    </div>
  </div>

  <div class="flex justify-center items-center mt-10">
    <div class="content-center shadow-sm rounded-lg bg-gray-50 border-1 min-h-32 w-full">
      <div class="flex justify-center items-center p-4">
        <p>{modalMessage}</p>
      </div>
    </div>
  </div>

  <div class="flex mx-auto justify-center mt-10">
    <button class="py-3 tracking-widest form-button" bind:this={buttonElement} on:click={handleClose}>閉じる</button>
  </div>
</div>

<style lang="postcss">
  .form-button {
    @apply text-center text-sm font-medium rounded-none text-white bg-[#0fb9f5] h-12 w-1/3;
  }

  .form-button:hover {
    text-decoration: none;
    -webkit-filter: brightness(1.1);
    filter: brightness(1.1);
  }
</style>
